export const environment = {
  production: false,
  /** Base API développement / préprod (avec ou sans slash final). */
  apiRdvUrl: 'https://dondesang.akimedia.eu/api/',
};
